import { FC, PropsWithChildren, useMemo } from "react";
import cx from "classnames";

import styles from "./CreateTrackersStep.module.scss";
import { Transition } from "src/components";
import { CreateTrackerStep } from "../../types";

type Props = PropsWithChildren & {
  step: CreateTrackerStep;
  currentStep: CreateTrackerStep;
  dashboard?: Dashboard.Data | null;
  className?: string;
};

// const TRANSITION_TIMEOUT: number = 500;

export const CreateTrackersStep: FC<Props> = ({
  step,
  children,
  currentStep,
  className,
}) => {
  // const previousCurrentStep = usePreviousState(currentStep);

  const isCurrentStep = useMemo<boolean>(
    () => step === currentStep,
    [currentStep, step],
  );

  // const stepIndex = useMemo<number>(
  //   () => CREATE_TRACKERS_STEPS.indexOf(step),
  //   [step],
  // );

  // const nextStep = useMemo<CreateTrackerStep>(
  //   () => CREATE_TRACKERS_STEPS[stepIndex + 1] || CREATE_TRACKERS_DEFAULT_STEP,
  //   [stepIndex],
  // );

  // const enterClassName = useMemo<string | undefined>(
  //   () =>
  //     previousCurrentStep === nextStep
  //       ? styles.slideInTop
  //       : styles.slideInBottom,
  //   [nextStep, previousCurrentStep],
  // );

  // const exitClassName = useMemo<string | undefined>(
  //   () =>
  //     currentStep === nextStep ? styles.slideOutTop : styles.slideOutBottom,
  //   [currentStep, nextStep],
  // );

  if (!isCurrentStep) return null;

  return (
    <Transition
      in={isCurrentStep}
      timeout={0}
      mountOnEnter
      unmountOnExit
      classNames={{
        enter: styles.slideInBottom,
        exit: styles.slideOutBottom,
      }}
    >
      <div className={cx(styles.wrapper, className)}>{children}</div>
    </Transition>
  );
};
